<template>
    <div class="pdf-layouts d-flex justify-center align-center">
        <v-btn
            :color="$mainColor"
            style="color:white"
            class="download-pdf"
            x-large
            @click="generateReport">Скачать</v-btn>
        
        <vue-html2pdf
            :show-layout="true"
            :float-layout="true"
            :enable-download="downloadPdf"
            :preview-modal="true"
            :paginate-elements-by-height="1100"
            filename="hee hee"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="775px"

            @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
        >
            <section class="slot-pdf-content pdf-content" slot="pdf-content">
                <div 
                class="pdf-content__header">
                    <div 
                    :Style="{color: $mainColor}"
                    class="name-pdf">
                        Заявка на эксперимент № {{detailInfo.id}}
                    </div>
                    <div class="pdf-content__logo-info d-flex align-center justify-start">
                        <img 
                        :src="logo"
                        class="logo"
                        >
                        <div 
                        :style="{color: $mainColor}"
                        class="d-flex align-center header-title">
                                {{ $t('NRCKI') }}
                        </div>
                    </div>
                </div>
                <div class="pdf-content__list-info">
                    <div 
                    :style="{border: `1px solid ${$mainColor}`}"
                    v-for="(item, keys, i) in detailInfo" :key="i"
                    :class="['pdf-content__list-info-item', i % 5 === 2 ? 'html2pdf__page-break' : null]">
                        <div 
                        :style="{backgroundColor: $mainColor}"
                        class="pdf-content__list-info-item-border">
                            {{$t(`Pdf`)[keys]}}
                        </div>
                        <p>
                            <template v-if="keys === 'method'">
                                <slot name="method"></slot>
                            </template>
                            <template v-else-if="keys === 'additional_equipment'">
                                <slot name="additional_equipment"></slot>
                            </template>
                            <template v-else-if="keys === 'expert'">
                                <slot name="expert"></slot>
                            </template>
                            <template v-else-if="keys === 'team'">
                                <slot name="team"></slot>
                            </template>
                            <template v-else-if="keys === 'scientific_subjects'">
                                <slot name="scientific_subjects"></slot>
                            </template>
                            <template v-else-if="keys === 'stations'">
                                <slot name="stations"></slot>
                            </template>
                            <template v-else-if="keys === 'previous_proposals'">
                                <slot name="previous_proposals"></slot>
                            </template>
                            <template v-else-if="keys === 'applicant'">
                                <slot name="applicant"></slot>
                            </template>
                            <template v-else-if="keys === 'status'">
                                <slot></slot>
                                <slot name="status"></slot>
                            </template>
                            <template v-else-if="keys === 'current_status'">
                                <slot name="current_status"></slot>
                            </template>
                            <template v-else-if="keys === 'comments'">
                                <slot name="comments"></slot>
                            </template>
                             <template v-else-if="keys === 'files'">
                                <slot name="files"></slot>
                            </template>
                            <template v-else>
                                {{(item === null ) || (item.length === 0) || (item === undefined) ? 'Нет данных' : item}}
                            </template>
                        </p>
                    </div>
                </div>
            </section>
        </vue-html2pdf>
    </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import logo from '../../assets/logo_black.png'

export default {
    name: 'PdfLayouts',
    props: {
        detailInfo: [Array, Object]
    },
    data() {
        return {
            logo,
            downloadPdf: false
        }
    },
    components: {
        VueHtml2pdf
    },
    methods: {
        generateReport () {
            this.downloadPdf = true
            this.$refs.html2Pdf.generatePdf()
        }
    },
}
</script>
<style>
.layout-container {
    margin-top: 48px;
    z-index: 1 !important;
}
.slot-pdf-content {
    margin-top: 50px;
    background: white;
    padding: 0 15px;
}
.pdf-layouts {
    padding: 15px;
    padding-top: 60px;
    width: 100%;
    height: 100vh;
    background: white;
}
.pdf-content__header {
    position: relative;
    top: 50px;
    width: 100%;
}
.name-pdf {
    float:left;
}
.pdf-content__logo-info img {
    float: left;
    vertical-align: middle;
}
.pdf-content__logo-info {
    width: 130px;
    position: absolute;
    top: 0;
    right: 0;
}
.pdf-content__logo-info .header-title {
    margin-top: -4px;
    margin-left: 15px;
}
.pdf-content__list-info {
    padding-top: 250px;
}
.pdf-content__list-info-item {
    margin-bottom: 15px;
}
.pdf-content__list-info-item p {
    margin-bottom: 0 !important;
    padding: 30px 10px;
}
.pdf-content__list-info-item-border {
    padding: 2px 10px;
    color: white;
}
.name-pdf,
.pdf-content .header-title {
    font-size: 20px;
}
.pdf-content .header-title {
    width: auto;
}
.download-pdf {
    position: absolute;
    top: calc(50% - 52px);
    right: 0;
    z-index: 3;
    padding-right: 60px !important;
}
</style>